//Components
import { Flex, Text } from '@/components';

//Icons
import { LogoSmall } from '@/assets/icons';

const MobileScreen = () => {
  return (
    <Flex h="100vh" justify="center" align="center" direction="column">
      <Flex w="fit-content" align="center">
        <LogoSmall />
        <Text clave="Signly" ml="15px" size="20px" />
      </Flex>
      <Flex w="300px" mt="15px">
        <Text
          clave="Por el momento la versión móvil no está disponible"
          textAlign="center"
        />
      </Flex>
    </Flex>
  );
};
export default MobileScreen;
